export default __webpack_public_path__ + "images/82177842f6fdadbee20cdad4cf479a59-yoga_small.webp";